export default __webpack_public_path__ + "static/media/gif.c4996dce.gif";